import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormRequestDTO, RequestTargets, RequestUserTarget } from "@main/formio/dto/formRequestDTO";
import { FormioRequestService } from "@main/formio/services/formioRequest.service";
import { UserService } from "@main/users";
import { MessageService, SelectItem } from "primeng/api";

@Component({
    selector: "formio-form-request-dialog",
    templateUrl: "./formio-form-request-dialog.component.html"
})

export class FormIOFormRequestDialogComponent implements OnInit {
    @Output() readonly onCancel = new EventEmitter();
    @Output() readonly onCreate = new EventEmitter();

    @Input() patientId: string = null;
    @Input() formRevisionId: string = null;
    @Input() episodeId: string = null;
    @Input() isMandatoryForm = false;
    showWarning = false;
    
    

    visible = true;
    
    targetGroups: SelectItem[] = [];
    displayNewFormRequestDialog = false;
    selectedTargetGroups: SelectItem[] = [];
    targetUsers: SelectItem[] = [];
    selectedTargetUsers: SelectItem[] = [];
    newFormRequest: FormRequestDTO = null;
    requestTargets?: RequestTargets;


    constructor(
        private userService: UserService,
        private formioRequestService : FormioRequestService,
        private messageService: MessageService,

     ) {  }

    async ngOnInit(): Promise<void> {
       await  this.getRequestFormData();
    }

    async getRequestFormData() {
        this.formioRequestService.getRequestTargets().then(data => {
            this.requestTargets = data;
            this.targetGroups = data.userType.map<SelectItem>(x => {
                return {
                    value: x.id,
                    label: x.name
                }
            });
        })
    }

    async onRoleChange(selectedRoles: { value: string, label: string }[]): Promise<void> {
        let allUsers: RequestUserTarget[] = [];

        selectedRoles.forEach(selectedRole => {
            const roleId = selectedRole.value;

            if (this.requestTargets.usersByRole[roleId]) {
              allUsers = allUsers.concat(this.requestTargets.usersByRole[roleId]);
            }
          });

          this.targetUsers = allUsers.map<SelectItem>(user => ({
            value: user.id,
            label: user.name
          }));
    }

    async Request() {
        if (this.selectedTargetUsers.some(x => x) || this.selectedTargetGroups.some(x => x)) {
            this.newFormRequest = {
            userIds: this.selectedTargetUsers.map(x => x.value),
            groupsIds: this.selectedTargetGroups.map(x => x.value),
            formRevisionId: this.formRevisionId,
            requesterId: this.userService.currentUser.id,
            requestDate: new Date(),
            patientId: this.patientId,
            episodeId: this.episodeId
            }
            const result = await this.formioRequestService.createRequest(this.newFormRequest);

        } else {
            this.messageService.add({
                severity: "info",
                summary: "Form request",
                detail: "You must select at least 1 user or group."
            });
        }
        this.newFormRequest = null;
        this.onCreate.emit( );
    }

    cancelRequest() {
        if (this.isMandatoryForm){
            this.showWarning = true;
            return;
        }
        this.newFormRequest = null;
        this.onCancel.emit( );
    }

 }
